"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResetSelectionOnOpen = void 0;
var _react = require("react");
const useResetSelectionOnOpen = (opened, selectedId, setFocusedId) => {
  (0, _react.useLayoutEffect)(() => {
    if (opened) {
      setFocusedId(selectedId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened]); // we want to reset the focus after open
};
exports.useResetSelectionOnOpen = useResetSelectionOnOpen;
//# sourceMappingURL=useResetSelectionOnOpen.js.map